// Sticky Header

gsap.to(".header-wrapper", {
    scrollTrigger: {
        trigger: ".header-wrapper-inner",
        start: "top top",
        endTrigger: "html",
        end: "bottom top",
        toggleClass: "is-stuck",
        pin: true,
        pinSpacing: false,
        scrub: 1
    }
});

window.addEventListener('resize', function() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.refresh();
});

/* Mega Menu */
// Set up the timeline
var tl = new TimelineMax({ paused: true });

// Define the animation for showing the mega menu

tl.to(".mega-menu-wrapper", 0.2, {
    display: "block",
    autoAlpha: 1,
  });

// Set up the hover event on the menu item
var menuItem = document.querySelector("nav li.mega-menu-parent");
menuItem.addEventListener("mouseenter", function () {
  tl.play();
  
});

menuItem.addEventListener("mouseleave", function () {
  tl.reverse().delay(1);
  
});


/*
Original smooth scroll function. Didn't handle internal page anchor links
Keeping commented out so I can reference it while writing a new function
*/
/*
// smooth scroll to anchor links with offset for sticky header
function scrollToAnchor() {
  // Check if the hash exists in the URL
  if (window.location.hash) {
    // Get the hash from the URL
    const hash = window.location.hash;

    // Get the target element using the hash
    const targetElement = document.querySelector(hash);

    // Check if the target element exists
    if (targetElement) {
      // Get the height of the sticky header
      const headerHeight = document.querySelector('.header-wrapper-inner').offsetHeight;

      // Calculate the target position by subtracting the header height from the element's position
      const targetPosition = targetElement.offsetTop - headerHeight;

      // Smoothly scroll to the target position
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }
}
window.onload = scrollToAnchor;
*/

/*
NEW FUNCTION
Smooth scroll to anchors on page load, as well as internal page anchor links
*/
function smoothScrollToAnchorWithOffset() {
  const currentUrl = window.location.href.split('#')[0];
  const links = document.getElementsByTagName('a');
  const headerHeight = document.querySelector('.header-wrapper-inner').offsetHeight;
  const hash = window.location.hash;

  // If there is a hash in the URL, scroll to anchor ID
  if (hash) {
    const targetId = hash.slice(1);
    const target = document.getElementById(targetId);
    if (target) {
      const targetTop = target.offsetTop - headerHeight;
      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    }
  }

  // Add click event listeners to anchor links that match the current URL
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    const href = link.href.split('#')[0];

    if (href === currentUrl) {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = link.hash.slice(1);
        const target = document.getElementById(targetId);
        const targetTop = target.offsetTop - headerHeight;
        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });
      });
    }
  }
}
window.onload = smoothScrollToAnchorWithOffset;